import { DisplayForHead } from "../../permissions/DisplayAccordingToRole";
import EditButton from "../buttons/EditButton";
import React from "react";
import styled, { css } from "styled-components";

const Stack = ({ id, label, editStrategy, isInteractive, value }) => {
  return (
    <Container $mode={id}>
      <div className={"flex-row"}>
        <h2> {label} </h2>
        {isInteractive && (
          <DisplayForHead
            component={<EditButton setUpdate={editStrategy} data={id} />}
          />
        )}
      </div>
      <p> {value !== "" ? value : "Pas encore défini"}</p>
    </Container>
  );
};

const Container = styled.div`
  width: 300px;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  border-radius: 15px;
  gap: 1rem;
  flex-grow: 1;

  .edit-btn {
    background-color: var(--color-white);

    &:hover {
      background: var(--color-blue-06);

      svg {
        fill: var(--color-white);
      }
    }
  }

  h2 {
    flex-grow: 1;
    font-size: 24px;
  }

  h2,
  p {
    color: var(--color-white);
    white-space: pre-line;
  }

  @media print {
    width: 100%;
    max-width: 100%;
  }

  ${(props) => {
    switch (props.$mode) {
      case "success":
        return css`
          background-color: var(--color-green-darker);
        `;
      case "vision":
        return css`
          background-color: var(--color-blue);
        `;
      case "goal":
        return css`
          background-color: var(--color-purple);
        `;
      case "duty":
        return css`
          background-color: var(--color-yellow);
        `;
      default:
        return css`
          background-color: var(--color-green);
        `;
    }
  }}
`;
export default Stack;
